import { render, staticRenderFns } from "./goodAndFails.vue?vue&type=template&id=039cde3e&"
import script from "./goodAndFails.vue?vue&type=script&lang=js&"
export * from "./goodAndFails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports